import * as React from 'react';
import { buildClassString } from '../StringUtils';
import { debounce } from '../TimingUtils';
import './style/index.scss';
class GrowAnimationContainer extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = Object.assign({}, this.state, {
            growState: props.initiallyExpanded ? 2 : 4
        });
        this._innerContainerRef = null;
        this._mounted = false;
        this._onTransitionEnd = this._onTransitionEnd.bind(this);
    }
    componentDidMount() {
        window.setTimeout(() => {
            if (!this._mounted) {
                return;
            }
            const { show } = this.props;
            const { growState } = this.state;
            this.setState({
                growState: growState === 4 && show ?
                    1 :
                    growState === 2 && !show ?
                        3 :
                        growState
            });
        }, 150);
        this._mounted = true;
        if (this._outerContainerRef) {
            this._outerContainerRef.addEventListener('transitionend', debounce(this._onTransitionEnd, 50));
        }
    }
    componentWillUnmount() {
        this._mounted = false;
    }
    componentDidUpdate() {
        const { growState } = this.state;
        const { show } = this.props;
        let newState = growState;
        if (show && (growState === 4 || growState === 3)) {
            newState = 1;
        }
        else if (!show &&
            (growState === 2 || growState === 1)) {
            newState = 3;
        }
        this.setState({
            growState: newState
        });
    }
    render() {
        const { children, fade, growDown, show } = this.props;
        const { growState } = this.state;
        let containerStyle = {};
        if (show && growState === 2) {
            containerStyle = { maxHeight: 'none' };
        }
        else if (growState === 1 || (!show && growState === 2)) {
            const maxHeight = this._innerContainerRef ?
                `${this._innerContainerRef.offsetHeight}px` :
                'none';
            containerStyle = { maxHeight };
        }
        const innerContainerClass = buildClassString({
            'inner-grow-container': true,
            'show': growState === 1 || growState === 2,
            'fade': fade,
            'grow-down': growDown
        });
        return (React.createElement("div", { className: "outer-grow-container", style: containerStyle, ref: ref => this._outerContainerRef = ref },
            React.createElement("div", { className: innerContainerClass, ref: ref => this._innerContainerRef = ref }, children)));
    }
    _onTransitionEnd() {
        const { growState } = this.state;
        let newState = growState;
        if (growState === 1) {
            newState = 2;
        }
        else if (growState === 3) {
            newState = 4;
        }
        this.setState({ growState: newState });
        const { onAnimationComplete } = this.props;
        if (onAnimationComplete) {
            onAnimationComplete();
        }
    }
}
export { GrowAnimationContainer };
export default GrowAnimationContainer;



// WEBPACK FOOTER //
// ./node_modules/@ps/payscale-shared-ui/lib/GrowAnimationContainer/index.js